import React from "react";
import InfoPageLayout from "../../components/InfoPageLayout";
import { Link } from "react-router-dom";

export default function LegalPage() {
  const legalSections = [
    {
      title: "Terms & Conditions",
      description: "Understand the rules and expectations for using our platform and services.",
      icon: "bi bi-file-earmark-text",
      link: "/terms"
    },
    {
      title: "Privacy & Cookie Policy",
      description: "Learn how we handle your data, privacy rights, and our data protection practices.",
      icon: "bi bi-shield-lock",
      link: "/privacy"
    },
    {
      title: "Disclaimer",
      description: "Read important disclaimers about the use of our services and tools.",
      icon: "bi bi-exclamation-triangle",
      link: "/disclaimer"
    },
    {
      title: "User Agreement",
      description: "Details on software licensing and how you are permitted to use our services.",
      icon: "bi bi-file-earmark-lock",
      link: "/user-agreement"
    },
    
    
  ];

  return (
    <InfoPageLayout title="Legal" description="Review our legal policies and company information.">
      <div className="container-fluid">
        <div className="row">
          {legalSections.map((section, index) => (
            <div className="col-lg-6 col-md-12 mb-4" key={index}>
              <Link to={section.link} className="text-decoration-none text-dark">
                <div className="card h-100 shadow-sm border-0">
                  <div className="card-body d-flex flex-column align-items-center text-center">
                    <div className="text-primary mb-3">
                      <i className={`${section.icon}`} style={{ fontSize: "3.5rem" }}></i>
                    </div>
                    <h5 className="fw-semibold">{section.title}</h5>
                    <p className="text-muted">{section.description}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </InfoPageLayout>
  );
}